import * as React from "react";
import { Navigate, useNavigate } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import Loader from "../Loader";

interface GuestGuardType {
  children: React.ReactNode;
}

// For routes that can only be accessed by unauthenticated users
function GuestGuard({ children }: GuestGuardType) {
  const navigate = useNavigate();
  const { isAuthenticated, isInitialized, invalidConfiguration } = useAuth();

  React.useEffect(() => {
    if (invalidConfiguration) {
      navigate("/invalid-configuration");
    }
  }, [navigate, invalidConfiguration]);

  if (!isInitialized) {
    return <Loader />;
  }

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default GuestGuard;
